import React from "react";

function Clearfix() {
    return <div className="custom-clearfix"></div>
}

export default Clearfix;


// WEBPACK FOOTER //
// ./src/components/Custom/Clearfix.jsx